import {Chip} from "@mui/material";
import {useTheme} from "../../../contexts/theme";


interface HighlightTypeProps {
    highlight_type: string;
}

export default function HighlightType({highlight_type}: HighlightTypeProps) {


    const theme = useTheme();

    return (
        <Chip
            variant={"outlined"}
            label={highlight_type}
            sx={{
                backgroundColor: theme.palette.orange,
                borderColor : theme.palette.orange
            }}
        />
    );
}